<template>
  <div class="create-user">
    <div
      v-if="selectedUser"
      class="create-user__title title"
    >
      Edit User
    </div>
    <div
      v-else
      class="create-user__title title"
    >
      Create New User
    </div>
    <div class="base-row">
      <span class="role-definitions-button" @click="$modal.show('permissions-matrix')">Role Definitions</span>
    </div>
    <div class="section">
      <div class="tabs">
        <span class="tabs_tab"
                    :class="{
                    'tabs_tab_active': selectedTab === tabs.userInfo,
                    'selectable': true}"
                    @click="selectedTab = tabs.userInfo"
                    >User Info</span>
        <span class="tabs_tab"
                    :class="{
                    'tabs_tab_active': selectedTab === tabs.permissions,
                    'selectable': true }"
                    @click="selectedTab = tabs.permissions"
                    >Edit Roles & Permissions</span>
        <span class="tabs_tab"
                    :class="{
                    'tabs_tab_active': selectedTab === tabs.clientRoles,
                    'selectable': true }"
                    @click="selectedTab = tabs.clientRoles"
                    >Active Roles</span>
      </div>
      <div class="tab-content" v-if="selectedTab === tabs.userInfo">
        <div class="user-info">
          <label class="label create-user__input">
            <span class="create-user__label">Is Active</span>
            <div
              class="create-user__user-wrapper"
            >
              <base-select
                v-model="user.is_active"
                :border-less="true"
                class="create-user__user-type"
                :options="activeOpts"
                :align-left="true"
                :title-style="titleStyle"
                :header-style="selectTypeStyle"
              />
            </div>
          </label>
          <label class="label create-user__input">
            <span class="create-user__label">First Name</span>
            <div
              class="create-user__user-wrapper"
            >
              <input
                v-model="user.first_name"
                type="text"
                class="form-control create-user__user-field"
              >
            </div>
          </label>
          <label class="label create-user__input">
            <span class="create-user__label">Last Name</span>
            <div
              class="create-user__user-wrapper"
            >
              <input
                v-model="user.last_name"
                type="text"
                class="form-control create-user__user-field"
              >
            </div>
          </label>
          <label class="label create-user__input">
            <span class="create-user__label">Email</span>
            <div
              class="create-user__user-wrapper"
            >
              <input
                v-model="user.email"
                type="text"
                class="form-control create-user__user-field"
              >
            </div>
          </label>
          <label v-if="selectedUser" class="label create-user__input">
            <span class="create-user__label">Account Confirmed</span>
            <div
              class="create-user__user-wrapper"
            >
              <span
                type="text"
                class="form-control create-user__user-field"
              >{{ user.account_confirmed }}</span>
            </div>
          </label>
        </div>
      </div>
      <div class="tab-content" v-if="selectedTab === tabs.permissions">
        <div v-if="!isDataFetched" class="loader">
          <base-loader/>
        </div>
        <template v-else>

          <div class="permissions-row">
              <base-select
                isSmartInput
                :smartInputStyle="{ 'padding-left': '20px' }"
                class="create-user__user-type permissions-header-column agency-selector"
                :options="agencyOpts"
                v-model="selectedAgency"
                :border-less="true"
                :align-left="true"
                :title-style="titleStyle"
                :header-style="selectTypeStyle"
                :placeholder-style="selectPlaceholderStyle"
                placeholder="Select Organization"
              />
            <span
              type="text"
              class="permissions-label permissions-header-column plan-span"
            >Plan: {{ permissionData[selectedAgency]?.plan ?? 'None' }}
            </span>
            <div
              class="permissions-radio-container permissions-header-column"
            >
              <span class="permissions-label">
              Admin Role:
              </span>
              <base-radio
                v-model="agencyAdminValue"
                style="margin-left: 20px"
                value="1"
                label="Enabled"
                class="permissions-radio"
                crossColor="#8F90A6"
                @change="updateAgencyAdmin"
              />
              <base-radio
                v-model="agencyAdminValue"
                style="margin-left: 30px"
                value="0"
                label="Disabled"
                class="permissions-radio"
                crossColor="#8F90A6"
                @change="updateAgencyAdmin"
              />
            </div>

          </div>
          <div class="permissions-row table-holder">
            <div class="permissions-projects-container">
              <div class="projects-table">
                <div class="table-row table-row__header row-stripe">
                  <div class="table-row__column">Project</div>
                  <div class="table-row__column">Project Role</div>
                </div>
                <template v-if="permissionData[selectedAgency]">
                  <div v-for="(project, i) in permissionData[selectedAgency].projects" class="table-row row-stripe" :key="i">
                    <div @click="!isDataUpdating && showPermissionModal(project)" :class="{ 'disabled-project-link': !project.role_group_id || isDataUpdating }" class="table-row__column project-link">
                      {{ project.project_name }}
                    </div>
                    <div class="table-row__column" v-if="project.project_id">
                      <base-select
                        v-model="project.role_group_id"
                        :border-less="true"
                        class="create-user__user-type"
                        :options="rolesList"
                        @change="updateProjectRole"
                        :align-left="true"
                        :title-style="titleStyle"
                        :header-style="selectTypeStyle"
                        :disabled="isDataUpdating"
                      />
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="tab-content" v-if="selectedTab === tabs.clientRoles">
        <div class="client-roles">
          <div v-if="!isDataFetched" class="loader">
            <base-loader/>
          </div>
          <template v-else>
            <div class="permissions-row">
              <div class="permissions-projects-container active-roles">
                <div class="projects-table">
                  <div class="table-row table-row__header row-stripe">
                    <div class="table-row__column">Organization</div>
                    <div class="table-row__column">Admin Role</div>
                  </div>
                  <div v-for="(permission, i) in currentAdminOrgs" class="table-row row-stripe" :key="i">
                    <div class="table-row__column project-link">
                      {{ permission.organization_name }}
                    </div>
                    <div class="table-row__column">
                      <base-radio
                        v-model="permissionData[permission.organization_id].agency_admin ? '1' : '0'"
                        value="1"
                        label="Enabled"
                        class="permissions-radio"
                        crossColor="#8F90A6"
                        @change="updateAdminFromActiveRoles(permission.organization_id, !permissionData[permission.organization_id].agency_admin)"
                      />
                      <base-radio
                        v-model="permissionData[permission.organization_id].agency_admin ? '1': '0'"
                        style="margin-left: 30px"
                        value="0"
                        label="Disabled"
                        class="permissions-radio"
                        crossColor="#8F90A6"
                        @change="updateAdminFromActiveRoles(permission.organization_id, !permissionData[permission.organization_id].agency_admin)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="permissions-row project-role-table">
              <div class="permissions-projects-container active-roles">
                <div class="projects-table">
                  <div class="table-row table-row__header row-stripe">
                    <div class="table-row__column">Project</div>
                    <div class="table-row__column">Organization</div>
                    <div class="table-row__column">Role</div>
                  </div>
                  <div v-for="(permission, i) in currentProjectRoles" class="table-row row-stripe" :key="i">
                    <div class="table-row__column project-link">
                      {{ permission.project_name }}
                    </div>
                    <div class="table-row__column project-link">
                      {{ permission.organization_name }}
                    </div>
                    <div class="table-row__column">
                      <base-select
                        v-model="permission.role_group_id"
                        :border-less="true"
                        class="create-user__user-type"
                        :options="rolesList"
                        @change="updateFromActiveRoles(permission.organization_id, permission.project_id, permission.role_group_id)"
                        :align-left="true"
                        :title-style="titleStyle"
                        :header-style="selectTypeStyle"
                        :disabled="isDataUpdating"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="create-user__controls controls">
          <button
            class="create-user__button cancel button"
            @click.prevent="close()"
          >
            Cancel
          </button>
          <template v-if="!selectedUser">
            <button
              v-if="selectedTab === tabs.userInfo"
              class="create-user__button submit button"
              @click="selectedTab = tabs.permissions"
            >
              Next
            </button>
            <button
              v-if="selectedTab === tabs.permissions"
              class="create-user__button submit button"
              @click="selectedTab = tabs.userInfo"
            >
              Previous
            </button>
          </template>
          <button
            class="create-user__button submit button"
            :class="{ disabled: !isUserValid() }"
            @click="apply"
          >
            Submit
          </button>

        <!-- <button
          v-if="selectedUser"
          class="create-user__button delete button"
          @click.prevent="deleteuser()"
        >
          Delete
        </button> -->
        <!-- <button
          class="create-user__button submit button"
          @click.prevent="apply()"
        >
          Apply
        </button> -->
      </div>
    </div>
    <modal
    name="permissions"
    v-bind="modalProps"
    >
      <EditPermissions
        :agencyRoutes="permissionData[selectedAgency]?.agency_routes ?? []"
        :roleRoutes="permissionData.role_routes ?? []"
        :selectedUser="user"
        :isAgencyAdmin="permissionData[selectedAgency]?.agency_admin ?? false"
        :selectedProject="selectedProject"
        @cancel="closePermissions"
        @roleUpdated="setProjectRole"
       />
    </modal>
    <modal
    name="permissions-matrix"
    v-bind="modalProps"
    >
      <PermissionsMatrix
        @cancel="$modal.hide('permissions-matrix')"
       />
    </modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import baseModalProps from '@/common/BaseModalProps'
import _ from 'lodash'
import moment from 'moment'
import BaseModalMixins from '@/common/BaseModalMixins'
import EditPermissions from './EditPermissions'
import PermissionsMatrix from './PermissionsMatrix'
import { update } from 'lodash'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
}
export default {
  name: 'CreateUpdateUserPopup',
  components: { EditPermissions, PermissionsMatrix },
  mixins: [BaseModalMixins],
  props: {
    selectedUser: {
      type: Object
    },
    selectedUserPermissions: {
      type: Object
    }
  },
  data () {
    return {
      user: _.cloneDeep(this.selectedUser) || {
        _id: 'add-new-user',
        first_name: '',
        last_name: '',
        email: '',
        account_confirmed: null,
        is_active: true,
      },
      project_roles_data: null,
      admin_orgs: null,
      agencyAdminValue: "0",
      selectedTab: 'userInfo',
      tabs: {
        userInfo: 'userInfo',
        permissions: 'permissions',
        clientRoles: 'clientRoles',
      },
      // should domain name selector be hidden or not
      titleStyle: {
        overflow: 'visible'
      },
      selectedAgency: null,
      selectedProject: null,
      permissionData: {},
      isDataFetched: false,
      isDataUpdating: false,
      initialPermissions: null,
      updatedPermissions: [],
      agencyOpts: [],
      activeOpts: [
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ],
      selectTypeStyle: _.cloneDeep(SELECT_STYLE),
      selectPlaceholderStyle: {
        color: '#b2b9be'
      }
    }
  },
  watch: {
    permissionData: {
      handler (newData) {
        this.updatedPermissions = []
        Object.keys(newData).filter(agencyId => {
          const hadPermission = this.initialPermissions.hasOwnProperty(agencyId)
          const hadProjectPermissions = hadPermission && this.initialPermissions[agencyId].hasOwnProperty('projects')
          const hadAgencyPermissions = hadPermission && this.initialPermissions[agencyId].hasOwnProperty('agency_admin')
          
          // Check if project roles have changed
          const updatedProjects = newData[agencyId].projects.filter((newProject) => {
            const oldProject = hadProjectPermissions && this.initialPermissions[agencyId].projects.find(oldProject => oldProject.project_id === newProject.project_id)
            if (oldProject && (newProject.role_group_id !== oldProject?.role_group_id)) {
              return true
            }
            if (!oldProject && newProject.role_group_id) {
              return true
            }
            return false
          })
          
          // Check if admin role has been changed
          let adminStatusChanged = false
          if (hadAgencyPermissions && (this.initialPermissions[agencyId].agency_admin !== newData[agencyId].agency_admin)) {
            adminStatusChanged = true
          } else if (!hadAgencyPermissions && newData[agencyId].agency_admin) {
            adminStatusChanged = true
          }

          // Construct object for updating
          if (adminStatusChanged || updatedProjects.length) {
            const updateObject = {
              agency_id: agencyId
            }
            if (adminStatusChanged) {
              updateObject.is_agency_admin = newData[agencyId].agency_admin
            }
            if (updatedProjects.length) {
              updateObject.projects = updatedProjects.map(project => ({ project_id: project.project_id, role_group_id: project.role_group_id }))
            }
            this.updatedPermissions.push(updateObject)
          }
        })
      },
      deep: true
    },
    selectedAgency (value) {
      if (!this.permissionData[value]) {
         return
      }
      this.resetAgencyAdminValue()
    },
    agencyAdminValue () {
      this.updateAgencyAdminValue()
    },
    selectedUser () {
      this.user = this.selectedUser
      if (this.selectedUser._id !== 'add-new-user') {
      }
    }
  },
  created () {
    this.loadPermissions()
    this.allowedAgencies.sort((a, b) => a.name < b.name ? -1 : 1)
    this.selectedAgency = this.selectedClient.fk_agency_id
    this.agencyOpts = this.allowedAgencies.map(agency => ({ label: agency.name, value: agency._id }))
  },
  computed: {
    currentProjectRoles () {
      let currentProjectRoles = this.updatedPermissions.filter(permission => permission.hasOwnProperty('projects'))
      currentProjectRoles = currentProjectRoles.reduce((acc, cur) => {
        // const obj = {
        //   organization_id: cur.agency_id,
        //   organization_name: this.agencies.find(agency => agency._id === cur.agency_id).name
        // }
        cur.projects.forEach(project => {
          // obj.project_id = project.project_id,
          // obj.project_name = this.clients.find(client => client._id === project.project_id).name
          // obj.role_group_id = project.role_group_id
          acc.push({
            organization_id: cur.agency_id,
            organization_name: this.agencies.find(agency => agency._id === cur.agency_id).name,
            project_id: project.project_id,
            project_name: this.clients.find(client => client._id === project.project_id).name,
            role_group_id: project.role_group_id
          })
        })
        return acc
      }, [])

      for (const agencyId in this.initialPermissions) {
        if (this.initialPermissions[agencyId].projects) {
          this.initialPermissions[agencyId].projects.forEach(initialProject => {
            const updatedPermission = this.updatedPermissions.find(permission => permission.agency_id === agencyId)
            let existsInUpdateList = false
            if (updatedPermission?.projects) {
              existsInUpdateList = updatedPermission.projects.find(updateProject => updateProject.project_id === initialProject.project_id)
            }
            if (initialProject.role_group_id && !existsInUpdateList) {
              currentProjectRoles.push({
                organization_id: agencyId,
                organization_name: this.agencies.find(agency => agency._id === agencyId).name,
                project_id: initialProject.project_id,
                project_name: this.clients.find(client => client._id === initialProject.project_id).name,
                role_group_id: initialProject.role_group_id,
              })
            }
          })
        }
      }

      currentProjectRoles.sort((a, b) => {
        return a.project_name < b.project_name ? -1 : 1
      })
      return currentProjectRoles
    },
    currentAdminOrgs () {
      let currentAdminOrgs = this.updatedPermissions.filter(permission => permission.hasOwnProperty('is_agency_admin'))
        .map(permission => ({
          organization_id: permission.agency_id,
          organization_name: this.agencies.find(agency => agency._id === permission.agency_id).name
        }))
      
      for (const agencyId in this.initialPermissions) {
        const hasAdminPermission = this.initialPermissions[agencyId].agency_admin
        const existsInUpdateList = this.updatedPermissions.find(permission => (permission.agency_id === agencyId) && permission.hasOwnProperty('is_agency_admin'))
        if (hasAdminPermission && !existsInUpdateList) {
          currentAdminOrgs.push({
            organization_id: agencyId,
            organization_name: this.agencies.find(agency => agency._id === agencyId).name
          })
        }
      }
      currentAdminOrgs.sort((a, b) => {
        return a.organization_name < b.organization_name ? -1 : 1
      })
      return currentAdminOrgs
    },
    modalProps () {
      const modalProps = {
        width: '60%'
      }
      return { ...baseModalProps, ...modalProps }
    },
    ...mapState(['agencies', 'roles']),
    ...mapState('userManager', ['adminAgencies']),
    isUserSuperAdmin () {
      return this.userRoles.includes('admin')
    },
    allowedAgencies () {
      return this.agencies.filter(agency => this.adminAgencies.includes(agency._id))
    },
    rolesList () {
      return [
        {
          value: null,
          name: null,
          label: 'Unassigned'
        },
        ...this.roles.filter(role => {
          return role.label !== 'Agency Admin'
        }).map(role => {
          return {
            value: role._id,
            label: role.label,
            name: role.name
          }
        })
      ]
    },
  },
  methods: {
    ...mapActions('userManager', ['getUserPermissions', 'updateUserData']),
    isUserValid () {
      // User should have email, full name
      let isValid = this.user.email && this.user.last_name && this.user.first_name

      // Edited user must have basic info. This is all the edited user needs if current user is super admin
      if (!isValid || this.isUserSuperAdmin) {
        return isValid
      }

      // If current user is not super admin, edited user should have at least one role / admin permission
      isValid = Object.keys(this.permissionData).some(agencyId => {
        const isAdmin = this.permissionData[agencyId].agency_admin
        const hasRole = this.permissionData[agencyId]?.projects.some(project => project.role_group_id)
        return isAdmin || hasRole
      })
      return isValid
    },
    updateFromActiveRoles (organizationId, projectId, roleGroupId) {
      const projectIndex = this.permissionData[organizationId].projects.findIndex(project => project?.project_id === projectId)
      if (projectIndex < 0) {
        this.permissionData[organizationId].projects.push({ agency_id: organizationId, project_id: projectId, role_group_id: roleGroupId })
      } else {
        this.permissionData[organizationId].projects[projectIndex].role_group_id = roleGroupId
      }
    },
    updateAdminFromActiveRoles (organizationId, isAdmin) {
      this.permissionData[organizationId].agency_admin = isAdmin
      if (this.selectedAgency === organizationId) {
        this.resetAgencyAdminValue()
      }
      this.$forceUpdate()
    },
    updateAdminOrgsFromPermissions () {
      const isAdmin = this.permissionData[this.selectedAgency].agency_admin
      if (isAdmin) {
        const existsInAdminOrgs = this.admin_orgs.find(org => org.organization_id === this.selectedAgency)
        if (!existsInAdminOrgs) {
          this.admin_orgs.push({
            organization_name: this.allowedAgencies.find(agency => agency._id === this.selectedAgency).name,
            organization_id: this.selectedAgency
          })
          this.admin_orgs.sort((a, b) => {
            return a.organization_name < b.organization_name ? -1 : 1
          })
        }
      }
    },
    updateClientRolesFromPermissions () {
      this.permissionData[this.selectedAgency].projects.forEach(project => {
        let permissionIdx = this.project_roles_data.findIndex(el => el.project_id === project.project_id)
        if (permissionIdx > -1) {
          this.project_roles_data[permissionIdx].role_group_id = project.role_group_id
        } else {
          this.project_roles_data.push({
            ...project,
            organization_id: this.selectedAgency,
            organization_name: this.allowedAgencies.find(agency => agency._id === this.selectedAgency).name
          })
        }
      })
      this.project_roles_data.sort((a, b) => {
        if (a.organization_name === b.organization_name){
          return a.project_name < b.project_name ? -1 : 1
        } else {
          return a.organization_name < b.organization_name ? -1 : 1
        }
      })
    },
    setProjectRole (projectId, roleId) {
      this.permissionData[this.selectedAgency].projects.find(project => project.project_id === projectId).role_group_id = roleId
      this.updateClientRolesFromPermissions()
    },
    closePermissions () {
      this.$modal.hide('permissions')
      this.selectedProject = null
    },
    updateAgencyAdminValue () {
      this.permissionData[this.selectedAgency].agency_admin = parseInt(this.agencyAdminValue) ? true : false
    },
    updateAgencyAdmin () {
      this.updateAgencyAdminValue()
      this.updateAdminOrgsFromPermissions()
    },
    async showPermissionModal (project) {
      if (project.role_group_id) {
        this.selectedProject = project
        this.$modal.show('permissions')
      }
    },
    updateProjectRole () {
      this.$forceUpdate()
      this.updateClientRolesFromPermissions()
    },
    async loadPermissions () {
      this.isDataFetched = false
      const permissionData = await this.getUserPermissions({ userId: this.user._id })
      this.permissionData = permissionData.agencies
      const initialPermissions = _.cloneDeep(permissionData.agencies)
      this.initialPermissions = Object.keys(initialPermissions).reduce((obj, currentAgencyId) => {
        const projectsWithRoles = initialPermissions[currentAgencyId].projects.filter(project => project.role_group_id)
        if (initialPermissions[currentAgencyId].agency_admin || projectsWithRoles.length) {
          obj[currentAgencyId] = {}
          if (initialPermissions[currentAgencyId].agency_admin) {
            obj[currentAgencyId].agency_admin = initialPermissions[currentAgencyId].agency_admin
          }
          if (projectsWithRoles.length) {
            obj[currentAgencyId].projects = projectsWithRoles
          }
        }
        return obj
      }, {})
      this.project_roles_data = permissionData.project_roles_data
      this.admin_orgs = permissionData.admin_orgs
      this.resetAgencyAdminValue()
      this.isDataFetched = true
    },
    /**
     * Handling decline creating new URL & hiding component
     */
    close () {
      this.$emit('cancel')
    },
    resetAgencyAdminValue () {
      this.agencyAdminValue = this.permissionData[this.selectedAgency].agency_admin ? '1' : '0'
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    async apply () {
      if (!this.isUserValid()) {
        return
      }
      const user = _.cloneDeep(this.user)
      user.permissions = this.updatedPermissions
      this.isDataUpdating = true
      const { id: updatedId } = await this.updateUserData({ 
        userId: user._id || 'add-new-user',
        email: user.email,
        last_name: user.last_name,
        first_name: user.first_name,
        is_active: user.is_active ? 1 : 0,
        permissions: user.permissions,
        successMessage: !user._id ? 'User created successfully' : 'User updated successfully'
      })
      this.isDataUpdating = false
      if (user._id === 'add-new-user') {
        this.$emit('apply', { ...user, _id: updatedId })
      } else {
        this.$emit('apply', user)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.project-role-table {
  margin-top: 20px;
}
.create-user {
  padding: 40px;
}

.project-link {
  cursor: pointer;
}
.disabled-project-link {
  cursor: default;
  color: $rfx-dark-grey;
}
.title {
text-align: center;
font-size: 34px;
font-weight: 500;
margin: 9px 0 35px;
color: $rfx-dark-march;
}

.base-row {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}
.role-definitions-button {
  color: $rfx-bright-blue;
  text-decoration: underline;
  cursor: pointer;
}

.input {
display: flex;
flex-direction: column;
position: relative;
margin-top: 30px;

.invalid[type='text'] {
    border: 1px solid $rfx-red;
    border-radius: 4px;
}
}

.label {
margin-top: 20px;
display: block;
font-weight: 600;
margin-bottom: 5px;
color: $rfx-dark-march;
}

.controls {
display: flex;
justify-content: flex-end;
margin-top: 20px;
}

.button {
  width: 100px;
  height: 40px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  margin-left: 30px;
  border: none;
  outline: none;
  cursor: pointer;

  &.submit {
      background-color: $rfx-medium-march;
      color: #fff;

      &:disabled {
      pointer-events: none;
      background-color: #fff;
      color: $rfx-neutral-grey;
      cursor: default;
      }
  }

  &.delete {
      background-color: $rfx-red;
      color: #fff
  }

  &.disabled {
      pointer-events: none;
      background-color: #fff;
      color: $rfx-neutral-grey;
      cursor: default;
  }

  &.cancel {
      color: $rfx-dark-march;
      background-color: #fff;
      border: $rfx-silver;
    
      &:hover {
        background-color: $rfx-almost-white;
      }
  }
}

.user-info,
.client-roles {
  height: 100%;
  margin-right: -20px;
  padding-right: 20px;
  overflow-y: auto;
}
.user {
  &-wrapper {
      position: relative;
      margin-top: 30px;

      &_single {
      margin-top: 0;
      }
  }

  .field[type='text'] {
      width: 100%;
      box-sizing: border-box;
      font-weight: 500;
      @include ellipsis;
  }
}

.error-message {
  color: $rfx-red;
  font-size: 10px;
  margin-top: 5px;
}

.date-wrapper {
  display: flex;
  font-weight: bold;
}

.date {
  flex: 0 0 30%;
  color: $rfx-dark-march;

  .error {
      color: $rfx-red;
  }
}

.form-control {
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  width: stretch;
  height: 50px;
  border: 2px solid $rfx-light-steel;
  outline: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: $rfx-dark-march;
  display: inline-block;
  line-height: 50px;
  margin-top: 5px;

  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
  }

  &:disabled {
    background-color: $rfx-light-steel;
  }

  &_error {
    border-color: $rfx-red;
    color: $rfx-red;

    &::placeholder {
      color: $rfx-red;
      font-size: 13px;
    }

  }
}

.section {
  display: flex;
  flex-direction: column;
  border-radius: 5px;
}

.permissions-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.plan-span {
  flex-grow: 1;
}
.agency-selector {
  width: 30%;
}
.permissions-label {
  height: 50px;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 600;
  color: $rfx-dark-march;
  display: block;
  line-height: 50px;
  flex: 1 0;
}

.permissions-radio-container {
  display: flex;
}
.permissions-radio {
  cursor: pointer;
}

.tab-content {
  border: 1px solid $rfx-light-steel;
  padding: 0 20px;
  height: 65vh;
  max-height: calc(100vh - 305px); // prevent vertical scroll on page level on smaller screen
  background-color: $rfx-almost-white-lighter;
  position: relative;
}

.tabs {
  cursor: pointer;
  display: flex;
  margin-bottom: -1px;

  &_tab {
    width: max-content;
    padding: 16px 9px;
    text-align: center;
    font-size: 14px;
    color: $rfx-light-march;
    background-color: transparent;
    border: 1px solid transparent;
    text-decoration: none;

    &_error {
      color: $rfx-red;
    }

    &_active {
      background-color: $rfx-almost-white-lighter;
      color: $rfx-dark-march;
      font-weight: bold;
      border: 1px solid $rfx-light-steel;
      border-bottom: 1px solid $rfx-almost-white-lighter;
      z-index: 1;
    }
  }
}
.loader {
    z-index: 1;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: rgba(255, 255, 255, .7);
}

.permissions-projects-container {
  margin-top: 10px;
  width: 100%;
}
.active-roles {
  border-top: 2px solid $rfx-light-march;
  border-radius: 1px 1px 0 0;
}

.projects-table {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.row-stripe:nth-child(odd) { 
  background: $rfx-light-steel;
}
.table-row {
  display: flex;
  font-size: 14px;
  border-radius: 4px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  &__header {
    font-weight: 600;
  }
  &__column {
    width: 50%;
  }
}
.table-row:first-of-type {
  border-radius: 0 0 4px 4px;
}
.table-holder {
  height: calc(100% - 50px);
  overflow-y: auto;
}
</style>
